
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexwSaUcLsBxLMeta } from "/codebuild/output/src4108035079/src/pages/index.vue?macro=true";
import { default as aboutsOaQxXLdAXMeta } from "/codebuild/output/src4108035079/src/pages/about.vue?macro=true";
import { default as data3iatlrDQ3hMeta } from "/codebuild/output/src4108035079/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptionmzl8GTK30xMeta } from "/codebuild/output/src4108035079/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioninglGaMILAr5GMeta } from "/codebuild/output/src4108035079/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacy83EuQSQK60Meta } from "/codebuild/output/src4108035079/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45account00MzMluDZrMeta } from "/codebuild/output/src4108035079/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statueyMkF63BsBdMeta } from "/codebuild/output/src4108035079/src/pages/account-settings/statue.vue?macro=true";
import { default as support0GBJgOwUIrMeta } from "/codebuild/output/src4108035079/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settingsqTmqI3Nvg4Meta } from "/codebuild/output/src4108035079/src/pages/account-settings.vue?macro=true";
import { default as activate_45accountiCgc7WuhfnMeta } from "/codebuild/output/src4108035079/src/pages/activate-account.vue?macro=true";
import { default as companylrzNZlHvcfMeta } from "/codebuild/output/src4108035079/src/pages/admin/company.vue?macro=true";
import { default as consentswMAyf5EBY8Meta } from "/codebuild/output/src4108035079/src/pages/admin/consents.vue?macro=true";
import { default as leadsk8qOy3CJjnMeta } from "/codebuild/output/src4108035079/src/pages/admin/leads.vue?macro=true";
import { default as paymentsSDFRj2cY0AMeta } from "/codebuild/output/src4108035079/src/pages/admin/payments.vue?macro=true";
import { default as premiumOX793FathgMeta } from "/codebuild/output/src4108035079/src/pages/admin/premium.vue?macro=true";
import { default as profilesj6Wz0t86YSMeta } from "/codebuild/output/src4108035079/src/pages/admin/profiles.vue?macro=true";
import { default as usersuHrAXOmHZMMeta } from "/codebuild/output/src4108035079/src/pages/admin/users.vue?macro=true";
import { default as change_45password5GuP2MPhuDMeta } from "/codebuild/output/src4108035079/src/pages/change-password.vue?macro=true";
import { default as _91id_93D8PI0Qw0diMeta } from "/codebuild/output/src4108035079/src/pages/chat/[id].vue?macro=true";
import { default as aiewBTtYkojVMeta } from "/codebuild/output/src4108035079/src/pages/chat/ai.vue?macro=true";
import { default as indexZLm1DGMxBOMeta } from "/codebuild/output/src4108035079/src/pages/chat/index.vue?macro=true";
import { default as chatBhvVoiAy8zMeta } from "/codebuild/output/src4108035079/src/pages/chat.vue?macro=true";
import { default as _91id_93CouFcnr2AMMeta } from "/codebuild/output/src4108035079/src/pages/client/profile/[id].vue?macro=true";
import { default as index2vMKlu1OamMeta } from "/codebuild/output/src4108035079/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_93apuBCiHy2OMeta } from "/codebuild/output/src4108035079/src/pages/contacts/[id].vue?macro=true";
import { default as indexvcmobsYFORMeta } from "/codebuild/output/src4108035079/src/pages/contacts/index.vue?macro=true";
import { default as contacts4UlDzrmZUNMeta } from "/codebuild/output/src4108035079/src/pages/contacts.vue?macro=true";
import { default as _91userId_93tADKFLXd67Meta } from "/codebuild/output/src4108035079/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as indexrCjaMqtBxeMeta } from "/codebuild/output/src4108035079/src/pages/login/index.vue?macro=true";
import { default as register_45successCeV5Zkdi7yMeta } from "/codebuild/output/src4108035079/src/pages/login/register-success.vue?macro=true";
import { default as login4bhcujIFxIMeta } from "/codebuild/output/src4108035079/src/pages/login.vue?macro=true";
import { default as logouthXSrVMo21wMeta } from "/codebuild/output/src4108035079/src/pages/logout.vue?macro=true";
import { default as consentskHdSYwqGeoMeta } from "/codebuild/output/src4108035079/src/pages/manager/consents.vue?macro=true";
import { default as integrations3nA4y2vJemMeta } from "/codebuild/output/src4108035079/src/pages/manager/integrations.vue?macro=true";
import { default as leadsC3qLeISo1eMeta } from "/codebuild/output/src4108035079/src/pages/manager/leads.vue?macro=true";
import { default as paymentsZOrhibfm0cMeta } from "/codebuild/output/src4108035079/src/pages/manager/payments.vue?macro=true";
import { default as profilenlP0IxDHTHMeta } from "/codebuild/output/src4108035079/src/pages/manager/profile.vue?macro=true";
import { default as teamH5JVijtCLUMeta } from "/codebuild/output/src4108035079/src/pages/manager/team.vue?macro=true";
import { default as indexdhQiKXCgqhMeta } from "/codebuild/output/src4108035079/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46clientjat1KV0LvDMeta } from "/codebuild/output/src4108035079/src/pages/marketplace/search/[catId].client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src4108035079/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as marketplaceiZM5o7vOmRMeta } from "/codebuild/output/src4108035079/src/pages/marketplace.vue?macro=true";
import { default as subscribe7vosemLzvyMeta } from "/codebuild/output/src4108035079/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46clientK2b6PZKXbfMeta } from "/codebuild/output/src4108035079/src/pages/orders/find.client.vue?macro=true";
import { default as my_46client5z3KnlSnSLMeta } from "/codebuild/output/src4108035079/src/pages/orders/my.client.vue?macro=true";
import { default as privacySkCdLZipH6Meta } from "/codebuild/output/src4108035079/src/pages/privacy.vue?macro=true";
import { default as indexHolCSEVftAMeta } from "/codebuild/output/src4108035079/src/pages/recover/index.vue?macro=true";
import { default as successrcBkMCbUqlMeta } from "/codebuild/output/src4108035079/src/pages/register/success.vue?macro=true";
import { default as _91id_93fNPVq3opPzMeta } from "/codebuild/output/src4108035079/src/pages/sales/profile/[id].vue?macro=true";
import { default as indexMcQbm9UeksMeta } from "/codebuild/output/src4108035079/src/pages/sales/profile/index.vue?macro=true";
import { default as statueBHD7kLZbBkMeta } from "/codebuild/output/src4108035079/src/pages/statue.vue?macro=true";
import { default as successieGNponeEwMeta } from "/codebuild/output/src4108035079/src/pages/subscription/success.vue?macro=true";
import { default as component_45stubVoyP77hiRDMeta } from "/codebuild/output/src4108035079/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubVoyP77hiRD } from "/codebuild/output/src4108035079/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexwSaUcLsBxLMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutsOaQxXLdAXMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: aboutsOaQxXLdAXMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settingsqTmqI3Nvg4Meta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src4108035079/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src4108035079/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src4108035079/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src4108035079/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src4108035079/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src4108035079/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src4108035079/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settingsqTmqI3Nvg4Meta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src4108035079/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src4108035079/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src4108035079/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src4108035079/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src4108035079/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src4108035079/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src4108035079/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45accountiCgc7WuhfnMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45accountiCgc7WuhfnMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: companylrzNZlHvcfMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: companylrzNZlHvcfMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consentswMAyf5EBY8Meta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consentswMAyf5EBY8Meta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leadsk8qOy3CJjnMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leadsk8qOy3CJjnMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: paymentsSDFRj2cY0AMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: paymentsSDFRj2cY0AMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premiumOX793FathgMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premiumOX793FathgMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profilesj6Wz0t86YSMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profilesj6Wz0t86YSMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: usersuHrAXOmHZMMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: usersuHrAXOmHZMMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45password5GuP2MPhuDMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45password5GuP2MPhuDMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/change-password.vue")
  },
  {
    name: chatBhvVoiAy8zMeta?.name,
    path: "/en/chat",
    meta: chatBhvVoiAy8zMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___en",
    path: ":id()",
    meta: _91id_93D8PI0Qw0diMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "ai",
    meta: aiewBTtYkojVMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/chat/ai.vue")
  },
  {
    name: "chat___en",
    path: "",
    meta: indexZLm1DGMxBOMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/chat/index.vue")
  }
]
  },
  {
    name: chatBhvVoiAy8zMeta?.name,
    path: "/pl/chat",
    meta: chatBhvVoiAy8zMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___pl",
    path: ":id()",
    meta: _91id_93D8PI0Qw0diMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___pl",
    path: "ai",
    meta: aiewBTtYkojVMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/chat/ai.vue")
  },
  {
    name: "chat___pl",
    path: "",
    meta: indexZLm1DGMxBOMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/chat/index.vue")
  }
]
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_93CouFcnr2AMMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_93CouFcnr2AMMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: index2vMKlu1OamMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: index2vMKlu1OamMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/client/profile/index.vue")
  },
  {
    name: contacts4UlDzrmZUNMeta?.name,
    path: "/en/contacts",
    meta: contacts4UlDzrmZUNMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_93apuBCiHy2OMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: indexvcmobsYFORMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contacts4UlDzrmZUNMeta?.name,
    path: "/pl/contacts",
    meta: contacts4UlDzrmZUNMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_93apuBCiHy2OMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: indexvcmobsYFORMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_93tADKFLXd67Meta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_93tADKFLXd67Meta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexwSaUcLsBxLMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: indexwSaUcLsBxLMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/index.vue")
  },
  {
    name: login4bhcujIFxIMeta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src4108035079/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: indexrCjaMqtBxeMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45successCeV5Zkdi7yMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: login4bhcujIFxIMeta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src4108035079/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: indexrCjaMqtBxeMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45successCeV5Zkdi7yMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logouthXSrVMo21wMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logouthXSrVMo21wMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consentskHdSYwqGeoMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consentskHdSYwqGeoMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrations3nA4y2vJemMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrations3nA4y2vJemMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leadsC3qLeISo1eMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leadsC3qLeISo1eMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: paymentsZOrhibfm0cMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: paymentsZOrhibfm0cMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profilenlP0IxDHTHMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profilenlP0IxDHTHMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: teamH5JVijtCLUMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: teamH5JVijtCLUMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/manager/team.vue")
  },
  {
    name: marketplaceiZM5o7vOmRMeta?.name,
    path: "/en/marketplace",
    meta: marketplaceiZM5o7vOmRMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src4108035079/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46clientjat1KV0LvDMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src4108035079/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplaceiZM5o7vOmRMeta?.name,
    path: "/pl/marketplace",
    meta: marketplaceiZM5o7vOmRMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src4108035079/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46clientjat1KV0LvDMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src4108035079/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscribe7vosemLzvyMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscribe7vosemLzvyMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46clientK2b6PZKXbfMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src4108035079/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46clientK2b6PZKXbfMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src4108035079/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46client5z3KnlSnSLMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src4108035079/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46client5z3KnlSnSLMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src4108035079/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacySkCdLZipH6Meta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacySkCdLZipH6Meta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: indexHolCSEVftAMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: indexHolCSEVftAMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src4108035079/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src4108035079/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_93fNPVq3opPzMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_93fNPVq3opPzMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: indexMcQbm9UeksMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: indexMcQbm9UeksMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statueBHD7kLZbBkMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statueBHD7kLZbBkMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: successieGNponeEwMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: successieGNponeEwMeta || {},
    component: () => import("/codebuild/output/src4108035079/src/pages/subscription/success.vue")
  },
  {
    name: component_45stubVoyP77hiRDMeta?.name,
    path: "/old-page",
    component: component_45stubVoyP77hiRD
  }
]